import { createContext, useContext, useState, useCallback, useRef } from "react";

const SearchContext = createContext(null);

export function SearchProvider({ children }) {
  const [query, setQuery] = useState("");
  const [matchCount, setMatchCount] = useState(0);
  const [currentMatch, setCurrentMatch] = useState(0);
  const matchRefs = useRef([]);

  const updateQuery = useCallback((q) => {
    setQuery(q);
    setCurrentMatch(0);
  }, []);

  const registerMatches = useCallback((refs) => {
    matchRefs.current = refs;
    setMatchCount(refs.length);
    if (refs.length > 0) {
      setCurrentMatch(1);
      refs[0]?.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      setCurrentMatch(0);
    }
  }, []);

  const goToNext = useCallback(() => {
    if (!matchRefs.current.length) return;
    const next = currentMatch % matchRefs.current.length;
    matchRefs.current[next]?.scrollIntoView({ behavior: "smooth", block: "center" });
    setCurrentMatch(next + 1);
  }, [currentMatch]);

  const goToPrev = useCallback(() => {
    if (!matchRefs.current.length) return;
    const prev = (currentMatch - 2 + matchRefs.current.length) % matchRefs.current.length;
    matchRefs.current[prev]?.scrollIntoView({ behavior: "smooth", block: "center" });
    setCurrentMatch(prev + 1);
  }, [currentMatch]);

  const clearSearch = useCallback(() => {
    setQuery("");
    setMatchCount(0);
    setCurrentMatch(0);
    matchRefs.current = [];
  }, []);

  return (
    <SearchContext.Provider value={{
      query, updateQuery,
      matchCount, currentMatch,
      registerMatches,
      goToNext, goToPrev, clearSearch,
    }}>
      {children}
    </SearchContext.Provider>
  );
}

export const useSearch = () => useContext(SearchContext);